import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { Typography } from 'components/uiKit/Typography'
import {
  BrandButtonFont,
  BrandFormFontBase,
  BrandGoBack,
  BrandRichTextFontForms,
  BrandRichTextTypography,
} from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestGroupingFormBrandType } from './testGroupingTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.testGrouping.font, {
  ...FONT_FIELDS,
  answerNumbering: FONT_FIELDS.base,
})

const TypographyAnswerNumbering: TestGroupingFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.answerNumbering}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.labeledGraphic.tags.numbering')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TestGroupingTypography: TestGroupingFormBrandType = ({
  device,
  edited,
  setForm,
  element,
}) => {
  const { font } = element || {}
  const values = useElementFontValues('testGrouping', device, font)
  const styles = useElementFontCss('testGrouping', device, font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottomSpace gap sides>
        <BrandGoBack onClick={goBack}>
          <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        </BrandGoBack>
        <BrandButtonFont
          edited={edited.font?.answerNumbering}
          font='answerNumbering'
          onClick={setForm}
          styles={styles.answerNumbering}
          values={values.answerNumbering}
        >
          {t('elements.labeledGraphic.tags.numbering')}
        </BrandButtonFont>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
      </Padding>
    </LayoutScroll>
  )
}

const FORM_MAP = {
  [BrandFormEnum.TYPOGRAPHY]: TestGroupingTypography,
  answerNumbering: TypographyAnswerNumbering,
  ...BrandRichTextFontForms,
}

export default FORM_MAP
